<template>
    <div @click="emitTabChange"
        :class="['item tw-mb-4 tw-flex tw-items-center tw-pl-4 tw-mb-4 secondary-c tw-cursor-pointer', { 'active tw-font-bold': active }]">
        <div class="tw-block">{{ text }}</div>
        <i :class="['fal fa-chevron-right tw-h-3 tw-ml-auto', { 'tw-font-bold': active }]"></i>
    </div>
</template>

<script>
export default {
    name: 'MenuItem',
    props: ['text', 'item', 'active_item'],
    computed: {
        active() {
            // active is when active_item is equal to name
            // or active_item is equal to one the items if the childTabs
            if (this.item.name === this.active_item) {
                return true;
            } else if (this.item.childTabs?.includes(this.active_item)) {
                return true;
            }
            return false;
        }
    },
    methods: {
        emitTabChange() {
            this.$emit('changeTab', this.item.name);
        }
    }
}
</script>
<style lang="scss" scoped>
.item.active {
    position: relative;

    &:before {
        content: "";
        display: block;
        width: 4px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        @apply tw-bg-blue-500;
    }
}
</style>